module.exports = __webpack_public_path__ + "img/headlogo.952b3aa0.png";